import { Networks } from 'automation-ui-action-features/actions/ads-audience-membership/constants';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as t from 'ts-schema';
import { jsx as _jsx } from "react/jsx-runtime";
const workflowAudiencesSchema = t.object({
  results: t.array(t.object({
    networkState: t.object({
      name: t.string
    }),
    targetingAudience: t.object({
      adNetwork: t.union(t.literal(Networks.ADWORDS), t.literal(Networks.FACEBOOK), t.literal(Networks.LINKEDIN)),
      id: t.number
    })
  }))
});
export const GET_WORKFLOW_AUDIENCES = registerQuery({
  fieldName: 'workflowAudiences',
  fetcher() {
    return http.get('ads/v1/audience/workflow-contact-list').then(response => {
      const validatedResponse = t.assert(workflowAudiencesSchema, response);
      return validatedResponse.results;
    });
  }
});
export function wireWorkflowAudiences(WrappedComponent) {
  return props => {
    const {
      data,
      loading
    } = useQuery(GET_WORKFLOW_AUDIENCES);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      isLoadingWorkflowAudiences: loading,
      workflowAudiences: data && data.workflowAudiences || []
    }));
  };
}